// imported in base router.ts
export default
	[{
		path: "/writtenpub/:id/:articletype?/",
		name: "writtenpub",
		component: () => import("@/Views/Articles/PublicationArticles.vue"),
		props: true,
		children: [],
		meta: { name: "Title Articles", page: "publication" }
	},

	{
		path: "/articles/:id/",
		name: "accountarticles",
		component: () => import("@/Views/Articles/AccountArticles.vue"),
		props: true,
		children: [],
		meta: { name: "Account Articles", page: "account" }
	}
	];
